import React, { useState } from 'react';
import { Row, Col, Table, Checkbox, Divider, Tag } from 'antd';
import { ExclamationCircleOutlined } from "@ant-design/icons";

import moment from 'moment'
import { FormatNumber } from '../../ValueObjects';

export default function TabProdutosVef({ dadosProdutosVef, setDadosProdutosVef }) {
    const [selecionaCheck, setSelecionaCheck] = useState(false);

    function selecionarNota(sequencia) {
        let lista = [...dadosProdutosVef];
        let nota = lista.find((nota) => { return nota.sequencia === sequencia });
        nota.checked = !nota.checked;
        setDadosProdutosVef(lista);
        if (!nota.checked) {
            setSelecionaCheck(false);
        }
        if (lista.every(nota => nota.checked === true)) {
            setSelecionaCheck(true);
        }
    }

    function selecionarTodas(checked) {
        let lista = [...dadosProdutosVef];
        lista.map((nota) => {
            nota.checked = (checked ? true : false);
            setSelecionaCheck(checked ? true : false);
        });
        setDadosProdutosVef(lista);
    }

    return (
        <div>
            <Row>
                <Col span={24}>
                    <div className="tabela tabelaVef t-mob">
                        <Table dataSource={dadosProdutosVef} bordered columns={[
                            {
                                title: 'Informações da Nota',
                                align: "center",
                                children: [
                                    {
                                        title: () => (
                                            <div>
                                                <Row gutter={[8, 0]} align='middle'>
                                                    <Col flex="30px">
                                                        <Checkbox checked={!!selecionaCheck} onClick={(event) => { selecionarTodas(event.target.checked) }} />
                                                    </Col>
                                                    <Col flex="auto" style={{ textAlign: "center" }}>
                                                        <b style={{ fontWeight: 500, color: "rgba(0, 0, 0, 0.85)"}}>Nº Nota</b>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ),
                                        align: 'center',
                                        width: 120,
                                        render: ({ ntf_numero, checked, sequencia }) => (
                                            <div>
                                                <Row gutter={[8, 0]} align='middle'>
                                                    <Col flex="30px">
                                                        <Checkbox checked={checked} onClick={() => { selecionarNota(sequencia) }} />
                                                    </Col>
                                                    <Col flex="auto" style={{ textAlign: "center" }}>
                                                        <Tag color="processing" className="w-75">
                                                            <b>{ntf_numero}</b>
                                                        </Tag>
                                                    </Col>
                                                </Row>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: 'Série',
                                        align: "center",
                                        render: ({ ser_serie }) => (
                                            <div>
                                                <b>{(ser_serie)}</b>
                                            </div>
                                        ),
                                    },
                                    {
                                        title: "Emissão",
                                        align: "center",
                                        render: ({ ntf_dataemissao }) => (
                                            <b>{moment(ntf_dataemissao).format('DD/MM/YYYY')}</b>
                                        )
                                    },
                                    {
                                        title: 'Total da Nota',
                                        align: "center",
                                        render: ({ valornotafiscal }) => (
                                            <b>R$ {FormatNumber(valornotafiscal, true)}</b>
                                        ),
                                    },
                                ]
                            },
                            {
                                title: 'Item da Nota',
                                align: "center",
                                children: [
                                    {
                                        title: "Código",
                                        align: "center",
                                        render: ({ pro_codigo }) => (
                                            <b>{pro_codigo}</b>
                                        )
                                    },
                                    {
                                        title: 'Descrição',
                                        render: ({ pro_descricao }) => (
                                            <b>{pro_descricao}</b>
                                        ),
                                    },
                                    {
                                        title: "Valor Unt.(R$)",
                                        align: 'right',
                                        render: ({ nfi_valorunitario }) => (
                                            <b>{FormatNumber(nfi_valorunitario, true)}</b>
                                        )
                                    },
                                    {
                                        title: "Saldo",
                                        width: 200,
                                        align: "center",
                                        render: ({ saldo }) => (
                                            <b className='f-18'>{saldo}</b>
                                        )
                                    },
                                ]
                            }
                        ]} locale={{
                            emptyText: (
                                <Row>
                                    <Col span={24}>
                                        <Divider orientation="center">
                                            <ExclamationCircleOutlined /> Nenhum Registro Encontrado
                                        </Divider>
                                    </Col>
                                </Row>
                            )
                        }}
                        />
                    </div>
                </Col>
            </Row>
        </div>
    )
}